"use strict";

var _interopRequireDefault = require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/interopRequireDefault");

var _objectSpread2 = _interopRequireDefault(require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/objectSpread2"));

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/asyncToGenerator"));

var _router = _interopRequireDefault(require("./router"));

var _store = _interopRequireDefault(require("./store"));

var _elementUi = require("element-ui");

var _nprogress = _interopRequireDefault(require("nprogress"));

require("nprogress/nprogress.css");

var _auth = require("@/utils/auth");

// progress bar
// progress bar style
_nprogress.default.configure({
  showSpinner: false
}); // 不显示进度环


var whiteList = ["/login", "/logisticsH5", "/goodsDetails"]; // no redirect whitelist

_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasMenu, _yield$store$dispatch, menu, accessRoutes;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            _nprogress.default.start(); // determine whether the user has logged in


            hasToken = (0, _auth.getToken)();

            if (!hasToken) {
              _context.next = 37;
              break;
            }

            if (!(to.path === "/login" || to.path === "/404" && from.name === "login")) {
              _context.next = 8;
              break;
            }

            // if is logged in, redirect to the home page
            next({
              path: "/"
            });

            _nprogress.default.done();

            _context.next = 35;
            break;

          case 8:
            hasMenu = _store.default.getters.menu && _store.default.getters.menu.length > 0;

            if (!hasMenu) {
              _context.next = 13;
              break;
            }

            next();
            _context.next = 35;
            break;

          case 13:
            _context.prev = 13;
            _context.next = 16;
            return _store.default.dispatch("user/getMenu");

          case 16:
            _yield$store$dispatch = _context.sent;
            menu = _yield$store$dispatch.menu;

            if (!(menu.length > 0)) {
              _context.next = 26;
              break;
            }

            _context.next = 21;
            return _store.default.dispatch("permission/generateRoutes", menu);

          case 21:
            accessRoutes = _context.sent;

            // dynamically add accessible routes
            _router.default.addRoutes(accessRoutes); // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record


            next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
              replace: true
            }));
            _context.next = 27;
            break;

          case 26:
            _store.default.dispatch("user/logout");

          case 27:
            _context.next = 35;
            break;

          case 29:
            _context.prev = 29;
            _context.t0 = _context["catch"](13);
            _context.next = 33;
            return _store.default.dispatch("user/resetToken");

          case 33:
            // Message.error({ message: error.msg || "Has Error" });
            next("/login?redirect=".concat(to.path));

            _nprogress.default.done();

          case 35:
            _context.next = 38;
            break;

          case 37:
            /* has no token*/
            if (whiteList.indexOf(to.path) !== -1) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              next("/login?redirect=".concat(to.path));

              _nprogress.default.done();
            }

          case 38:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[13, 29]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});